import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { useTeamForm } from '@hooks/useTeam'

interface TeamDetailsProps {
  teamFormPayload: ReturnType<typeof useTeamForm>,
}

const TeamDetails = (props: TeamDetailsProps) => {
  const {
    teamFormPayload: {
      entityState: {
        description,
        title,
      },
      errors,
      handlers,
    },
  } = props

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Details">
      <Form padding="large">
        <Form.Field errorMessage={errors.title} label="* Title">
          <input name="title" type="text" value={title} {...handlers} />
        </Form.Field>

        <Form.Field label="Description" marginTop="large">
          {/*
           // @ts-expect-error TS2322 */}
          <textarea
            name="description"
            style={{ minHeight: 100, resize: 'vertical' }}
            value={description}
            {...handlers}
          />
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

export default TeamDetails
